<template>
  <button class="confirmation__close" @click="closeDeleteDialog">
    <IconClose aria-label="Schließen" />
  </button>
  <h2 class="confirmation__title">Termin wirklich stornieren?</h2>
  <p class="confirmation__subtitle">
    {{
      `Möchten Sie Ihren Termin “${dialogInfo.services}” am ${dialogInfo.date} um ${dialogInfo.time} Uhr wirklich stornieren? Diese Aktion kann nicht rückgängig gemacht werden.`
    }}
  </p>
  <div class="confirmation__buttons">
    <Button label="Abbrechen" outline @clicked="closeDeleteDialog" />
    <Button label="Termin stornieren" @clicked="deleteAppointment" />
  </div>
</template>

<script>
import { trackGa4Event } from '@/utils/tracking'

import Button from '@/components/Button.vue'
import IconClose from '@/components/icons/IconClose.vue'

export default {
  components: { IconClose, Button },
  props: {
    dialogInfo: {
      type: Object,
    },
  },
  emits: ['closeDeleteDialog'],
  methods: {
    closeDeleteDialog() {
      this.$emit('closeDeleteDialog')
    },
    async deleteAppointment() {
			if (this.dialogInfo.isOtb) {
				await this.$store.dispatch('otbAppointment/deleteOtbAppointment', this.dialogInfo.id)
				this.$store.dispatch('getOtbAppointments')
			} else {
				await this.$store.dispatch('deleteAppointment', this.dialogInfo.id)
				this.$store.dispatch('getUserAppointments')
				// User cancels their appointment
				trackGa4Event({
					ga4Event: 'tvg_cancel_appointment',
					ga4ParameterName: 'action',
					ga4ParameterValue: 'cancel',
				})
			}

      this.closeDeleteDialog()

    },
  },
}
</script>

<style lang="scss">
.confirmation {
  &__close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }

  #content &__title,
  &__title {
    font-weight: $font-weight-medium;
    margin-bottom: 8px;
    font-size: 16px;
    line-height: $line-height;
  }

  &__subtitle {
    color: $color-text-secondary;
    margin-bottom: 24px;
  }

  &__buttons {
    display: flex;
    gap: 8px;

    @media (max-width: $breakpoint-max-mobile) {
      flex-direction: column;
    }

    .button {
      width: 100%;

      @media (max-width: $breakpoint-max-mobile) {
        &:first-of-type {
          order: 2;
        }
        &:last-of-type {
          order: 1;
        }
      }
    }
  }

  &__button {
    display: flex;
    justify-content: center;
  }
}
</style>
